// extracted by mini-css-extract-plugin
export default {"container":"loader_container__Ue4S9","loading":"loader_loading__4tObr"};